<template>
  <div>
    <TemplateBookBookingPaymentSelection v-if="isReadyToDraw" />
    <DialogInitialLoading v-else />
  </div>
</template>

<script>
import { computed, ref, onMounted } from "vue";
import { useStore } from "vuex";
import API from "@/API";
import nativeHandlerService from "@/services/nativeHandler";

import TemplateBookBookingPaymentSelection from "@/views/Templates/TicketStore/TemplateBookBookingPaymentSelection";
import bookGroupService from "@/services/bookGroup";

export default {
  name: "BookBookingPaymentSelection",
  components: {
    TemplateBookBookingPaymentSelection: TemplateBookBookingPaymentSelection,
  },
  setup() {
    const store = useStore();

    const isReadyToDraw = ref(false);

    // requried data
    const masterBook = computed(() => store.getters["ticketing/masterBook"]);
    const bookGroup = computed(() => store.getters["ticketing/bookGroup"]);

    const divisionCalTotalPrice = computed(() =>
      bookGroupService.calTotal(bookGroup.value)
    );

    onMounted(async () => {
      try {
        if (divisionCalTotalPrice.value == 0) {
          store.commit("ticketing/setPaymentMethods", [{ name: "取得無料" }]);
        } else {
          //fetch payment methods
          await API.getPaymentMethodsForMasterBook(masterBook.value.id);
        }
        isReadyToDraw.value = true;
      } catch (err) {
        console.log(err);
        nativeHandlerService.ncSendTicketingError(
          "BookBookingPaymentSelection onMounted()",
          JSON.stringify(err)
        );
      }
    });

    return {
      isReadyToDraw,
    };
  },
};
</script>
